/** Конкурсы: список и страница конкурса. */
import { useQuery } from '@tanstack/react-query';

import { apiGet } from '@/shared/api/client';
import { raffleDetailSchema, rafflesSchema } from '@/shared/api/schemas';
import { isGuest } from '@/shared/lib/guest';

export function useRaffles() {
  return useQuery({
    queryKey: ['raffles'],
    queryFn: () => apiGet('/raffles', rafflesSchema),
    staleTime: 60_000,
    // У гостя нет аккаунта — и билетов тоже.
    enabled: !isGuest(),
  });
}

export function useRaffle(id: string | undefined) {
  return useQuery({
    queryKey: ['raffle', id],
    queryFn: () => apiGet(`/raffles/${id}`, raffleDetailSchema),
    enabled: Boolean(id) && !isGuest(),
  });
}

const dateFmt = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', timeZone: 'Europe/Moscow' });
const dateTimeFmt = new Intl.DateTimeFormat('ru-RU', {
  day: 'numeric',
  month: 'long',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'Europe/Moscow',
});

/** «Розыгрыш 30 ноября в 20:00» или «дата розыгрыша будет объявлена». */
export function drawText(raffle: { status: string; draw_at: string | null; ends_at: string | null }): string {
  if (raffle.status === 'drawn') return 'Итоги подведены';
  if (raffle.draw_at) return `Розыгрыш ${dateTimeFmt.format(new Date(raffle.draw_at))} МСК`;
  if (raffle.ends_at) return `Билеты — до ${dateFmt.format(new Date(raffle.ends_at))}`;
  return 'Дата розыгрыша будет объявлена';
}

export function shortDate(iso: string): string {
  return dateFmt.format(new Date(iso));
}
